import React, { useEffect, useState } from 'react';

const OccupationAutocomplete = ({ currentQuestion, storeAnswers, selectedAnswer, parentAnswerKey, subQuestion }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [occupations, setOccupations] = useState(null);

    // Hard coded this as for some reason it's not getting passed through in the props.
    parentAnswerKey = 2;

    // Set default search field value.
    if (parentAnswerKey && searchTerm.length === 0 && selectedAnswer.hasOwnProperty(parentAnswerKey)) {
        setSearchTerm(selectedAnswer[parentAnswerKey].text);
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchOccupations(searchTerm);
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    const handleSearchTermChange = (event) => {
        const enteredText = event.target.value;
        setSearchTerm(enteredText);

        if (enteredText.length > 5) {
            storeSelectedAnswer(enteredText);
        }
    };

    const fetchOccupations = (search_term) => {
        fetch('https://nu-partners-api.herokuapp.com/api/v1/occupation/searchRecord/' + search_term)
            .then(function (response) {
                if (response.status !== 200) {
                    console.error('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }

                response.json().then(function (data) {
                    setOccupations(data.slice(0, 30));
                });
            })
            .catch(function (error) {
                console.error(error);
            });
    };

    const storeSelectedAnswer = (enteredText) => {
        if (occupations && occupations.length > 0) {
            let text = '';
            let eligible = false;

            occupations.forEach((occupation) => {
                if (occupation.name === enteredText) {
                    text = occupation.name;
                    eligible = occupation.eligible === 0 ? false : true;
                }
            });

            const answer = {
                text: text,
                eligible: eligible,
                nextQuestion: eligible ? null : 13,
            };

            storeAnswers(0, answer, currentQuestion, parentAnswerKey);
        }
    };

    return (
        <>
            <input
                type='text'
                list='occupations'
                value={searchTerm}
                placeholder='Type to start searching for occupations'
                className='occupation_autocomplete'
                onChange={handleSearchTermChange}
            />
            <datalist id='occupations'>
                {occupations &&
                    occupations.map((occupation) => {
                        return <option>{occupation.name}</option>;
                    })}
                <option>Nobody in my household is employed.</option>
            </datalist>
        </>
    );
};

export default OccupationAutocomplete;
